import 'reflect-metadata';
import { inject, injectable } from 'inversify';
import { TYPES } from '@Types';
import { RequestAction, RequestFailure } from '../../RequestAction';
import { Nullable } from '@Models';
import { ApiClient } from '@Api';
import { Locale } from '../../locale';
import { RequestMatchesSuccess } from './response';
import { MatchMapper } from '@Mapper/tool/pairing/MatchMapper';

@injectable()
export class MatchRepository {
  @inject(TYPES.Mapper.MatchMapper) private _mapper!: MatchMapper;
  @inject(TYPES.Api.ApiClient) private _apiClient!: ApiClient;
  @inject(TYPES.Locale) private _locale!: Locale;

  public async getAll({
    draftId,
    locale,
  }: {
    draftId: string;
    locale: Nullable<string>;
  }): Promise<RequestAction> {
    try {
      const dto = await this._apiClient.toolPairing.getMatches({
        id: draftId,
        locale: locale ?? this._locale.getlocale(),
      });
      return new RequestMatchesSuccess({
        payload: dto.map((item) => this._mapper.map(item)),
      });
    } catch (error: any) {
      return new RequestFailure({ error: error });
    }
  }
}
